(function() { window.GUID_0785f71e_5fee_443b_b26c_2f9e5ad807d6 = { getGuid: function() { return "0785f71e-5fee-443b-b26c-2f9e5ad807d6"; } }; })();
var CS;
(function (CS) {
    var Views;
    (function (Views) {
        var Account;
        (function (Account) {
            class Signup extends Views.ViewBase {
                get BackgroundImageId() {
                    return this.backgroundImageId;
                }
                get BackgroundImageClass() {
                    return this.backgroundImageClass;
                }
                OnDispose() {
                    CS.DOM.$body.off("click", "#link-terms-of-service");
                    CS.DOM.$body.off("click", "#link-privacy-policy");
                    $('#button-signup-with-email').off("click");
                    $(`#${this.BackgroundImageId}`).remove();
                }
                OnAllCssFilesLoaded() {
                    // #signup-container n'est pas affiché malgré qu'il y ait des erreures une fois que la page est reloadée après une erreure (lorsque la case à cocher "user agreements" est présente)
                    if ($('.validation-summary-errors').length > 0) {
                        this.ShowSignUp();
                    }
                }
                constructor() {
                    super();
                    this.backgroundImageId = "cs-background-img";
                    this.backgroundImageClass = "background-img__signup";
                    this.waitRECAPTCHA = null;
                    let me = this;
                    me.SetSignupBackgroundImage();
                    $('#button-signup-with-email').on('click', function () {
                        me.ShowSignUp();
                    });
                    // #signup-container n'est pas affiché malgré qu'il y ait des erreures une fois que la page est reloadée après une erreure (lorsque la case à cocher "user agreements" est présente)
                    //if ($('.validation-summary-errors').length > 0) {
                    //    me.ShowSignUp();
                    //}
                    //if ($('.validation-summary-errors').length > 0) {
                    //    $('#button-signup-with-email').hide();
                    //    $('#signup-container').show();
                    //    //me.ShowSignInEmail();
                    //}
                    //$("#textbox-firstname-child").rules("add", {
                    //    normalizer: function (value) { return $.trim(value); }
                    //});
                    //$("#textbox-lastname-child").rules("add", {
                    //    normalizer: function (value) { return $.trim(value); }
                    //});
                }
                ShowSignUp() {
                    $('#button-signup-with-email').hide();
                    $('#signup-container').slideDown(200, 'linear');
                }
                SetSignupBackgroundImage() {
                    let me = this, $backgroundImageElement = $(`#${me.BackgroundImageId}`);
                    if ($backgroundImageElement.length == 0) {
                        let backgroundImageElement = `<div id="${me.BackgroundImageId}" class="${me.BackgroundImageClass}"></div>`;
                        CS.DOM.$sectionMiddle.prepend(backgroundImageElement);
                    }
                }
            }
            Account.Signup = Signup;
            Views.PageContext.OnPageLoaded({ controllerName: "account", actionName: "signup" }, () => new Signup());
        })(Account = Views.Account || (Views.Account = {}));
    })(Views = CS.Views || (CS.Views = {}));
})(CS || (CS = {}));

//# sourceMappingURL=account.signup.js.map
